<script lang="ts" setup>
import type { PropType } from '#imports';

defineProps({
  data: {
    type: Object as PropType<any>,
    default: () => ({}),
  },
});
</script>

<template>
  <a
    :href="data.url"
    target="_blank"
    class="mt-3 block w-full rounded !bg-[#f6f7f8] px-3 pb-3 pt-2"
  >
    <div class="flex h-5 items-center justify-between">
      <a-tag class="!h-[18px] !px-[2px] !text-[12px] !leading-4 !text-font2 !rounded-sm">{{
        data.tag
      }}</a-tag>
      <div
        class="mt-1 text-xs leading-5"
        :class="data.color ? 'text-success' : 'text-error'"
      >
        {{ data.status }}
      </div>
    </div>

    <div
      :title="data.title"
      class="break-word mt-2 line-clamp-2 text-sm leading-5 text-colorText transition-colors hover:text-info"
    >
      {{ data.title }}
    </div>
  </a>
</template>

<style scoped>

</style>